export const locale = {
    lang: 'en',
    data: {
        BUTTONS: {
            ADD: 'Thêm mới',
            EDIT: 'Cập nhật',
            DELETE: 'Xóa',
            LOCK: 'Khóa/Mở khóa',
            SHOW_INACTIVE: 'Hiển thị bản ghi bị khóa',
            EXPORT_EXCEL: 'Xuất excel',
            EXPORT_PDF: 'Xuất PDF',
            IMPORT: 'Nhập file',
            SAVE: 'Lưu lại',
            CANCEL: 'Hủy bỏ',
            BACK: 'Quay lại',
            PRINT: 'In',
            PREVIEW: 'Preview'
        },
        notify: {
            ERROR_UNDEFINED: 'Lỗi không xác định!',
            SERVER_ERROR: 'Lỗi server!',
            ADD_SUCCESS: 'Thêm mới dữ liệu thành công!',
            EDIT_SUCCESS: 'Sửa dữ liệu thành công!',
            DELETE_SUCCESS: 'Xóa dữ liệu thành công!',
            ADD_ERROR: 'Thêm mới dữ liệu không thành công!',
            EDIT_ERROR: 'Sửa dữ liệu không thành công!',
            DELETE_ERROR: 'Xóa dữ liệu không thành công!',
            NO_RECORD_SELECT: 'Chưa bản ghi nào được chọn!'
        }
    }
};
